import { useMemo } from 'react';

const countries = require('./country-codes.json').map(function (a) {
    return { name: a.name, code: a.code, dial_code: a.dial_code.replace(' ', '') };
});

function useE164() {
    const e164Rgx = useMemo(() => {
        return /^\+[1-9]\d{10,14}$/;
    }, []);

    const getCountriesFromE164 = function (phoneNumber) {
        return countries.filter(function (a) {
            return phoneNumber.startsWith(a.dial_code);
        });
    };

    const getFormatMethod = function (countryCode) {
        switch (countryCode) {
            //https://en.wikipedia.org/wiki/National_conventions_for_writing_telephone_numbers#United_States,_Canada,_and_other_NANP_countries
            case 'AS':
            case 'AI':
            case 'AG':
            case 'BS':
            case 'BB':
            case 'BM':
            case 'VG':
            case 'CA':
            case 'KY':
            case 'DM':
            case 'DO':
            case 'GD':
            case 'GU':
            case 'JM':
            case 'MS':
            case 'MP':
            case 'PR':
            case 'KN':
            case 'LC':
            case 'VC':
            case 'TT':
            case 'TC':
            case 'US':
            case 'VI':
                return function (phoneNumber) {
                    return `(${phoneNumber.substring(2, 5)}) ${phoneNumber.substring(5, 8)}-${phoneNumber.substring(8, 12)}`;
                };

            //https://en.wikipedia.org/wiki/National_conventions_for_writing_telephone_numbers#India
            case 'IN':
                return function (phoneNumber) {
                    return `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(3, 8)} ${phoneNumber.substring(8, 13)}`;
                };

            //https://en.wikipedia.org/wiki/National_conventions_for_writing_telephone_numbers#Mexico
            case 'MX':
                return function (phoneNumber) {
                    return `${phoneNumber.substring(3, 5)} ${phoneNumber.substring(5, 9)} ${phoneNumber.substring(9, 13)}`;
                };

            default:
                return false;
        }
    };

    //Expects a number already formatted to conform to E164
    const fromE164 = (phoneNumber, customMask) => {
        if (!phoneNumber || !e164Rgx.test(phoneNumber)) return phoneNumber;

        if (customMask) {
            return customMask
                .split('')
                .map((a) => {
                    if (Number.isInteger(parseInt(a))) return phoneNumber[parseInt(a) + 2];
                    return a;
                })
                .join('');
        }
        let phoneCountry = getCountriesFromE164(phoneNumber)[0];
        let formatMethod = getFormatMethod(phoneCountry.code);
        if (!formatMethod) {
            console.error(`No phone formatting method written for ${phoneCountry.name}`);
            return phoneNumber;
        }
        return formatMethod(phoneNumber);
    };

    //Expects a user-entered number
    const toE164 = (phoneNumber) => {
        let _phoneNumber = phoneNumber.replace(/\D/g, '');
        if (!_phoneNumber || !(_phoneNumber.length === 10 || _phoneNumber.length === 11)) return phoneNumber;

        return _phoneNumber.length === 11 ? `+${_phoneNumber}` : `+1${_phoneNumber}`;
    };

    const normalize = (phoneNumber) => {
        let _phoneNumber = phoneNumber.replace(/\D/g, '');
        if (!_phoneNumber || !(_phoneNumber.length === 10 || _phoneNumber.length === 11)) return phoneNumber;

        _phoneNumber = toE164(_phoneNumber);

        return fromE164(_phoneNumber);
    };

    return { fromE164, toE164, normalize };
}

export default useE164;
